import { adminAuthApi } from "./api";

// GET: 상담내용(Counsel) 사용자 리스트 조회
export const adminGetUserListForCounselApi = (searchTerm) => adminAuthApi.get(`/counsel/users?searchTerm=${searchTerm}`)

// GET: 상담내용(Counsel) 리스트 조회
export const adminGetCounselListApi = (userId, searchTerm) => adminAuthApi.get(`/counsel/list/${userId}?searchTerm=${searchTerm}`)

// GET: 상담내용 조회 by counselId
export const adminGetCounselInfoApi = (counselId) => adminAuthApi.get(`/counsel/${counselId}`)

// POST: 상담내용(Counsel) 저장
export const adminSaveCounselApi = (formData, userId) => adminAuthApi.post(
    `/counsel/${userId}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
)

// DELETE: 상담내용 삭제
export const adminDeleteCounselApi = (counselId) => adminAuthApi.delete(`/counsel/${counselId}`)